import { Directive, HostListener, OnDestroy, OnInit } from '@angular/core';
import { debounceTime, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { TextfieldComponent } from '../textfield/textfield.component';
import { getControl } from '@shared/helpers/form.helper';

@Directive({ selector: 'textfield[revertOnInvalid]' })
export class RevertOnInvalidDirective implements OnInit, OnDestroy {
    private lastValidValue: string = '';
    private control: FormControl;
    private readonly _destroy$ = new Subject<void>();

    constructor(private textfield: TextfieldComponent, private toastrService: ToastrService) {}

    ngOnInit(): void {
        this.control = getControl(this.textfield.form, this.textfield.fieldName);
        this.lastValidValue = this.control.value ?? '';

        this.control.statusChanges.pipe(debounceTime(300), takeUntil(this._destroy$)).subscribe((status) => {
            if (status === 'VALID') {
                this.lastValidValue = this.control.value ?? '';
            }
        });
    }

    @HostListener('focusout')
    onFocusOut(): void {
        if (!this.control?.errors) return;

        const hasNonRequiredError = Object.keys(this.control.errors).some((k) => k !== 'required');
        if (!hasNonRequiredError) return;

        const firstErrorKey = Object.keys(this.control.errors).find((k) => k !== 'required');
        const errorBody = this.control.errors[firstErrorKey];
        const message: string = errorBody?.message ?? errorBody?.status ?? 'Valore non valido';

        this.control.setValue(this.lastValidValue, { emitEvent: true });
        this.toastrService.error(message, undefined, {
            timeOut: 1500,
            extendedTimeOut: 1000,
            disableTimeOut: false,
        });
    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
